<template>
<div v-for="row in rows" :key="row">
<!-- {{ row }} -->

<div v-for="col in this.$store.state.metaPrint.columns" :key="col">
          <base-geo-cell v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
</div>

</div>




</template>
<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
export default {
    name: 'standard-print-page',
    components: {
      PointWidget,
      DateWidget,

    },
    props:['meta', 'rows'],
    data(){ 
        return {
        }
    },
    methods: {

    },


  


}
</script>